module.exports = __webpack_public_path__ + "static/media/gym-zoomed-4.4d394c0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/gym-zoomed-4.jpg
// module id = 2387
// module chunks = 0